import { IUserMigrationStatus } from "@/interfaces/user"
import React from "react"
import './index.css';
import { Button } from "flowbite-react";

interface Props {
  userMigration: IUserMigrationStatus
}

const formatDateString = (date: Date) => {
  const d = (date instanceof Date) ? date : new Date(date);
  const [year, month, day] = d.toISOString().slice(0, 10).split('-');
  return `${day}/${month}/${year}`;
}

const redirectToSuperPortal = (speLinkRedrect: string) => {
  window.open(speLinkRedrect, '_self');
}

const ExperimentationSpeBanner: React.FC<Props> = ({ userMigration }: Props) => {
  const showDeadlineToMigrateMessage = userMigration?.status == "EXPERIMENTACAO" && userMigration?.deadlineToMigrate;
  return (
    <>
      <div id="experimentation-spe-banner">
        <div className='flex bg-quaternary justify-center items-center container'>
          <div className='max-w-[1600px] w-50 flex mx-auto'>
            <div className="p-4 image-container">
              <img src='/images/experimentation-banner.png' className="image" />
            </div>
            <div className="p-4 pb-0">
              <div>
                <span className="title">Experimente o SuperPortal e volte quando precisar</span>
              </div>
              <div className="subtitle-container">
                <span className="subtitle">Nos ajude a tornar a VR ainda melhor e mais segura para você!</span>
              </div>
            </div>
            <div className="p-4 button-access-spe-container">
              <Button
                type="button"
                className="button-access-spe"
                onClick={() => redirectToSuperPortal(userMigration.linkSpeRedirect)}
              >
                Acessar SuperPortal
              </Button>
            </div>
          </div>
        </div>
        {showDeadlineToMigrateMessage && (
          <div className='flex bg-quaternary justify-center items-center p-1 content-date-limit'>
            <p>A partir de <b>{formatDateString(userMigration.deadlineToMigrate)}</b> o seu acesso passará a ser exclusivo via SuperPortal VR. </p>
          </div>
        )}
      </div>
    </>
  )
}

export default ExperimentationSpeBanner
